import { call, put } from 'redux-saga/effects';
import { default as api } from '../../util/api';
import { ECOM_ORDERS_URL } from '../../util/constants/api.constants';
import { fetchEcomOrdersList, fetchEcomOrdersListSuccess, fetchEcomOrdersListFailed, fetchEcomShippingSuccess, fetchEcomShippingFailed, fetchEcomShipping } from './ecomOrders-actions';
import { showErrorNotification, showSuccessNotification } from '../../util/notifications';
import { notification } from 'antd';
import React from 'react';

export function* fetchEcomOrders(): Generator {
  try {
    const data: any = yield call(api.get, ECOM_ORDERS_URL.REQUEST_ECOM_ORDERS);
    yield put(fetchEcomOrdersListSuccess(data));
  } catch (e: any) {
    yield put(fetchEcomOrdersListFailed(e.message));
    showErrorNotification(null, e.message);
  }
}

export function* processEcomOrdersSaga({ payload }: any): Generator {
  try {
    yield call(api.post, ECOM_ORDERS_URL.PROCESS_ECOM_ORDERS, payload);
    showSuccessNotification('Orders processed successfully');
    yield put(fetchEcomOrdersList());
  } catch (e: any) {
    const errorMessages = e?.response?.data?.error?.messages;
    if (errorMessages && Array.isArray(errorMessages)) {
      notification.error({
        key: 'processEcomOrdersError',
        message: 'Process Ecom Orders Failed',
        description: React.createElement(
          'div',
          { style: { maxHeight: '300px', overflowY: 'auto' } },
          errorMessages.map((msg: string, index: number) =>
            React.createElement(
              'div',
              {
                key: index,
                style: {
                  padding: '4px 0',
                  borderBottom: index < errorMessages.length - 1 ? '1px solid #f0f0f0' : 'none',
                  color: '#cf1322',
                  fontSize: '13px',
                },
              },
              msg
            )
          )
        ),
        duration: 0,
        placement: 'topRight',
        style: { width: 420 },
      });
    } else {
      showErrorNotification(null, e.message);
    }
  }
}

export function* fetchEcomShippingSaga(): Generator {
  try {
    const data: any = yield call(api.get, ECOM_ORDERS_URL.ECOM_SHIPPING);
    yield put(fetchEcomShippingSuccess(data));
  } catch (e: any) {
    yield put(fetchEcomShippingFailed(e.message));
    showErrorNotification(null, e.message);
  }
}

export function* saveEcomShippingSaga({ payload }: any): Generator {
  try {
    yield call(api.post, ECOM_ORDERS_URL.ECOM_SHIPPING, payload);
    showSuccessNotification('Shipping configuration saved successfully');
    yield put(fetchEcomShipping());
  } catch (e: any) {
    showErrorNotification(null, e.message);
  }
}

export function* cancelEcomOrdersSaga({ payload }: any): Generator {
  try {
    yield call(api.post, ECOM_ORDERS_URL.CANCEL_ECOM_ORDERS, payload);
    showSuccessNotification('Orders cancelled successfully');
    yield put(fetchEcomOrdersList());
  } catch (e: any) {
    showErrorNotification(null, e.message);
  }
}
